/**
 * Date-extensions locale Luxembourgish [lb]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('lb', {
    monthNames: ['Januar','Februar','Mäerz','Abrëll','Mee','Juni','Juli','August','September','Oktober','November','Dezember'],
    monthShortNames: ['Jan.','Febr.','Mrz.','Abr.','Mee','Jun.','Jul.','Aug.','Sept.','Okt.','Nov.','Dez.'],
    dayNames: ['Sonndeg','Méindeg','Dënschdeg','Mëttwoch','Donneschdeg','Freideg','Samschdeg'],
    dayShortNames: ['So.','Mé.','Dë.','Më.','Do.','Fr.','Sa.']
});
